import {Routes, Route,BrowserRouter} from 'react-router-dom';
import { useAuthContext } from './adminlogin/useAuthContext';
import {useStudentAuthContext} from './student/useStudentAuthContext';
import AdminHome from './adminlogin/AdminHome';
import AdminLogin from './adminlogin/AdminLogin';
import Header from './admin/Header';
import ManageReligion from './admin/religion/ManageReligion';
import AddReligion from './admin/religion/AddReligion';
import ManageCaste from './admin/caste/ManageCaste';
import AddCaste from './admin/caste/AddCaste';
import StudentIndex from './student';
import StudentHeader from './student/Header';
import StudentRegister from './student/register';
import StudentHome from './student/StudentHome';
import StudentLogin from './student/StudentLogin';
import StudentApplication from './student/StudentApplication';
import StudentDocument from './studentdocument/StudentDocument';
import ManageStudent from './admin/student/ManageStudent';
import ViewApplication from './admin/student/ViewApplication';
import ViewDocuments from './admin/student/ViewDocuments';
import ProcessApplication from './admin/student/ProcessApplication';
import Terms from './static/Terms';
import ManageSubCaste from './admin/subcaste/ManageSubCaste';
import AddSubCaste from './admin/subcaste/AddSubCaste';
import StudentSearch from './student/StudentSearch';
import { StudentPublic } from './student/StudentPublic';
import StudentDashboard from './student/StudentDashboard';

function App() {
  const {adminuser} = useAuthContext();
  const {studentuser} = useStudentAuthContext();

 
  
  return (
    <BrowserRouter>
        <Routes>



                 <Route
                  path='/terms'
                  element={
                    <>
                     <StudentHeader />
                    <Terms/>
                    </>
                    }
                  />
                  <Route
                  path='/dashboard'
                  element={
                    <>
                     <StudentHeader />
                    <StudentDashboard/>
                    </>
                    }
                  />  
                  <Route
                  path='/search'
                  element={
                    <>
                     <StudentHeader />
                    <StudentSearch/>
                    </>
                    }
                  />

                <Route
                  path='/student/:id'
                  element={
                    <>
                     <StudentHeader />
                    <StudentPublic/>
                    </>
                    }
                  />

      

      
                <Route
                  path='/'
                  element={
                    studentuser ?
                    <>
                     <StudentHeader />
                     <StudentHome />
                    </>
                    :
                    <>
                     <StudentHeader />
                     <StudentIndex />
                    </>
                    }
                  />

                  <Route
                  path='/student/register'
                  element={
                    studentuser ?
                    <>
                    <StudentHeader />
                    <StudentHome />
                   </>
                    :
                    <>
                     <StudentHeader />
                     <StudentRegister />
                    </>
                    }
                  />

                  <Route
                  path='/student/login'
                  element={
                    studentuser ?
                    <>
                     <StudentHeader />
                     <StudentHome />
                    </>
                    :
                    <>
                    <StudentHeader />
                    <StudentLogin/>
                    </>
                    }
                  />

                  <Route
                  path='/student/home'
                  element={
                    studentuser ?
                    <> 
                    <StudentHeader />
                    <StudentHome />
                    </> 
                    :
                   
                    <>
                    <StudentHeader />
                    <StudentLogin />
                   </>
                   
                    }
                  />

                  <Route
                  path='/student/application'
                  element={
                    studentuser ?
                    <> 
                      <StudentHeader />
                      <StudentApplication />
                    </> 
                    :
                    <>
                    <StudentHeader />
                    <StudentLogin />
                   </>
                    }
                  />

                  <Route
                  path='/student/documents'
                  element={
                    studentuser ?
                    <> 
                      <StudentHeader />
                      <StudentDocument />
                    </> 
                    :
                    <>
                    <StudentHeader />
                    <StudentLogin />
                   </>
                    }
                  />


               {/* Admin Routes defined from here  */}
              <Route
                  path='/admin'
                  element={
                    adminuser ?
                    <> 
                    <Header />
                    <AdminHome />
                    </> 
                    :
                    <>
                    <Header />
                    <AdminLogin/>
                    </>
                    }
                  />

           

              <Route
                  path='/admin/religion'
                  element={
                    adminuser ?
                    <> 
                    <Header />
                    <ManageReligion />
                    </> 
                    :
                    <>
                    <Header />
                    <AdminLogin/>
                    </>
                    }
                  />  

                  <Route
                  path='/admin/religion/create'
                  element={
                    adminuser ?
                    <> 
                    <Header />
                    <AddReligion />
                    </> 
                    :
                    <>
                    <Header />
                    <AdminLogin/>
                    </>
                    }
                  />   

                <Route
                  path='/admin/caste'
                  element={
                    adminuser ?
                    <> 
                    <Header />
                    <ManageCaste />
                    </> 
                    :
                    <>
                    <Header />
                    <AdminLogin/>
                    </>
                    }
                  />  

                  <Route
                  path='/admin/caste/create'
                  element={
                    adminuser ?
                    <> 
                    <Header />
                    <AddCaste />
                    </> 
                    :
                    <>
                    <Header />
                    <AdminLogin/>
                    </>
                    }
                  />  

                <Route
                  path='/admin/subcaste'
                  element={
                    adminuser ?
                    <> 
                    <Header />
                   <ManageSubCaste />
                    </> 
                    :
                    <>
                    <Header />
                    <AdminLogin/>
                    </>
                    }
                  />  

                  <Route
                  path='/admin/subcaste/create'
                  element={
                    adminuser ?
                    <> 
                    <Header />
                    <AddSubCaste />
                    </> 
                    :
                    <>
                    <Header />
                    <AdminLogin/>
                    </>
                    }
                  />  

                  <Route
                  path='/admin/student-applications'
                  element={
                    adminuser ?
                    <> 
                    <Header />
                    <ManageStudent />
                    </> 
                    :
                    <>
                    <Header />
                    <AdminLogin/>
                    </>
                    }
                  />   

                  <Route
                  path='/admin/view-application/:id'
                  element={
                    adminuser ?
                    <> 
                    <Header />
                    <ViewApplication />
                    </> 
                    :
                    <>
                    <Header />
                    <AdminLogin/>
                    </>
                    }
                  />   

                <Route
                  path='/admin/view-documents/:id'
                  element={
                    adminuser ?
                    <> 
                    <Header />
                    <ViewDocuments />
                    </> 
                    :
                    <>
                    <Header />
                    <AdminLogin/>
                    </>
                    }
                  />   

                <Route
    path="/admin/process-application/:id"
    element={
        <>
            <Header />
            <ProcessApplication />
        </>
    }
/>

<Route
    path="*"
    element={
        <div style={{ padding: '50px', color: 'red' }}>
            <h1>ROUTE NOT FOUND</h1>
            <p>Current URL: {window.location.pathname}</p>
        </div>
    }
/>



            </Routes>

       </BrowserRouter>
      

  );
}

export default App;
